const apiEndPoints = {
  findCalulatesForPatientId: (patientId) => `api/v1/estadoSaludCalculado/ultimoEstadoDeSalud/${patientId}/relations=[estadoDeSaludData]`,
  findEstadoSaludData: (patiendId) => `api/v1/estadoSalud/paciente/${patiendId}`
}

export default apiEndPoints



// WEBPACK FOOTER //
// ./src/components/EstaDoSaludDashboard/apiEndPoints.js